import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  approvePaymentRunLockAPI,
  type ApprovePaymentRunLockParams,
  type GetPaymentRunReviewParams,
} from '~entities/payment/api/reporting-payment-run-review';
import { QUERY_KEYS } from '~shared/api/query-keys';

export type { ApprovePaymentRunLockParams } from '~entities/payment/api/reporting-payment-run-review';

export interface UseApprovePaymentRunLockOptions {
  /** When provided, invalidates this report query on success */
  reportParams?: GetPaymentRunReviewParams;
}

export const useApprovePaymentRunLockMutation = (
  options?: UseApprovePaymentRunLockOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ApprovePaymentRunLockParams) =>
      approvePaymentRunLockAPI(params),
    onSuccess: (_data, _variables) => {
      if (options?.reportParams) {
        void queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW(options.reportParams),
        });
      }
    },
  });
};
